module.exports = "/images/promotion-background.png?be908e1a08dcf880cd8c1f703a4d3e57";